import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrThickArrowLeftIconComponent: TemplateOnlyComponent<Signature> =
  <template>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      class={{@class}}
      ...attributes
    >
      <path
        d='M11.6653 14.658C12.1116 14.2023 12.1116 13.4636 11.6652 13.008L6.75915 8.00007L11.6653 2.99148C12.1116 2.53585 12.1116 1.79712 11.6653 1.34148C11.2189 0.885847 10.4953 0.885847 10.049 1.34148L4.33474 7.17512C4.1204 7.39393 3.99999 7.69071 4 8.00016C4.00001 8.3096 4.12044 8.60637 4.33479 8.82517L10.0491 14.6581C10.4954 15.1137 11.219 15.1136 11.6653 14.658Z'
        fill='currentColor'
      />
    </svg>
  </template>;

export default WrThickArrowLeftIconComponent;
